import { initHeader } from './header';
import { initContactModal } from './modal';
import { initTestimonials } from './testimonials';
import { initContactPageForm } from './contact-page-form';
import { initFaqPage } from './faq-page';
import { initLandingFaq } from './landing-fire';

const initPageTransitionsFallback = () => {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const supportsViewTransitions = typeof document.startViewTransition === 'function';

    if (prefersReducedMotion || supportsViewTransitions) {
        return;
    }

    const isSameOriginNavigation = (url) => {
        try {
            return url.origin === window.location.origin;
        } catch (error) {
            return false;
        }
    };

    document.addEventListener('click', (event) => {
        if (event.defaultPrevented || event.button !== 0) {
            return;
        }

        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
            return;
        }

        const link = event.target.closest('a[href]');
        if (!link) {
            return;
        }

        if (link.target === '_blank' || link.hasAttribute('download')) {
            return;
        }

        const nextUrl = new URL(link.href, window.location.href);
        if (!isSameOriginNavigation(nextUrl)) {
            return;
        }

        const sameDocumentAnchor = nextUrl.pathname === window.location.pathname
            && nextUrl.search === window.location.search
            && nextUrl.hash;
        if (sameDocumentAnchor) {
            return;
        }

        event.preventDefault();
        document.body.classList.add('is-page-leaving');
        window.setTimeout(() => {
            window.location.assign(nextUrl.toString());
        }, 360);
    });

    window.addEventListener('pageshow', () => {
        document.body.classList.remove('is-page-leaving');
    });
};

document.addEventListener("DOMContentLoaded", function () {
    initHeader();
    initContactModal();
    initTestimonials();
    initContactPageForm();
    initFaqPage();
    initLandingFaq();
    initPageTransitionsFallback();
});
